import EditDocumentForm from "../AddDocuments/EditDocumentForm";
import permissions from "app/permissions";
import { DocumentServicePath } from "utils/constants";

//permissions
export const resources = {
  isMenu: false,
  name: DocumentServicePath + "add-documents/declarations/:id",
  permission: permissions.canPreviewDeclarations,
  custom: <EditDocumentForm />,
};
